export default __webpack_public_path__ + "static/media/publish-icon.4ab7dde3.svg";